function adjustReadMore() {
  if (window.innerWidth < 750) {
    var showChar = 250;
    var ellipsestext = "";
     var moretext = "Read More";
    var lesstext = "Read Less";
    var lookBookDescriptions = document.querySelectorAll('.read_more_content');
    lookBookDescriptions.forEach(function(lookBookDescription) {
      var content = lookBookDescription.innerHTML;
      if (content.length > showChar) {
        var c = content.substr(0, showChar);
        var h = content.substr(showChar, content.length - showChar);
        var html = c + '<span class="moreellipses">' + ellipsestext + '<span class="readdots">...</span></span><span class="morecontent"><span style="display:none;">' + h + '</span><a href="#" class="morelink">' + moretext + '</a></span>';
        lookBookDescription.innerHTML = html;
      }
    });
    var moreLinks = document.querySelectorAll('.morelink');
    moreLinks.forEach(function(moreLink) {
      moreLink.addEventListener('click', function(event) {
        event.preventDefault();
        var isLess = this.classList.contains('less');
        if (isLess) {
          this.classList.remove('less');
          this.innerHTML = moretext;
        } else {
          this.classList.add('less');
          this.innerHTML = lesstext;
        }
        this.parentElement.previousElementSibling.style.display = isLess ? 'inline' : 'none';
        this.previousElementSibling.style.display = isLess ? 'none' : 'inline';
      });
    });
  } else {
    // Show the inner span elements with class "morecontent" inside paragraphs with class "read_more_content"
    document.querySelectorAll("p.read_more_content span.morecontent span").forEach(function(element) {
      element.style.display = "inline"; // or "block" depending on the desired display style
    });

    // Hide the "morelink" anchor elements inside paragraphs with class "read_more_content"
    document.querySelectorAll("p.read_more_content span.morecontent a.morelink").forEach(function(element) {
      element.style.display = "none";
    });
  }
}
document.addEventListener('DOMContentLoaded', function() {
// Call the function initially
adjustReadMore();
});
// Call the function whenever the window is resized
// window.addEventListener('resize', adjustReadMore);
